import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import WithDrawRequest from "./WithDrawRequest";
import AcceptedRequest from "./AcceptedRequest";
import DeclinedRequest from "./DeclinedRequest";
import WithDrawDetails from "./WithDrawDetails";
import InfoDialog from "./InfoDialog";
import ReasonViewDialog from "./ReasonViewDialog";
import { getWithdrawStatsData } from "../../store/withdraw/withdraw.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconFileDescription,
  IconCalendarEvent,
  IconClockHour4,
  IconCircleCheck,
  IconCircleX,
  IconCalendarCheck,
  IconCalendarX,
  IconCash,
  IconCashBanknote,
  IconCashOff,
} from "@tabler/icons-react";

const ManageWithDraw = () => {
  const dispatch = useDispatch();
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { withdrawStatsData } = useSelector((state) => state.withdraw);

  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("User");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getWithdrawStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Request",
      count: withdrawStatsData?.totalRequest,
      Icon: IconFileDescription,
    },
    {
      title: "Received Today",
      count: withdrawStatsData?.receivedToday,
      Icon: IconCalendarEvent,
    },
    {
      title: "Pending Request",
      count: withdrawStatsData?.pendingRequest,
      Icon: IconClockHour4,
    },
    {
      title: "Approved Request",
      count: withdrawStatsData?.approvedRequest,
      Icon: IconCircleCheck,
    },
    {
      title: "Rejected Request",
      count: withdrawStatsData?.rejectedRequest,
      Icon: IconCircleX,
    },
    {
      title: "Accepted Today",
      count: withdrawStatsData?.acceptedToday,
      Icon: IconCalendarCheck,
    },
    {
      title: "Rejected Today",
      count: withdrawStatsData?.rejectedToday,
      Icon: IconCalendarX,
    },
    {
      title: "Total Pending Amount",
      count: withdrawStatsData?.totalPendingAmount,
      Icon: IconCash,
    },
    {
      title: "Total Accepted Amount",
      count: withdrawStatsData?.totalAcceptedAmount,
      Icon: IconCashBanknote,
    },
    {
      title: "Total Rejected Amount",
      count: withdrawStatsData?.totalRejectedAmount,
      Icon: IconCashOff,
    },
  ];

  return (
    <>
      <div className="userPage">
        <div>
          <div className="dashboardHeader primeHeader mb-3 p-0">
            <NewTitle
              dayAnalyticsShow={true}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              startDate={startDate}
              endDate={endDate}
              setMultiButtonSelect={handleMultiButtonSelect}
              multiButtonSelect={multiButtonSelect}
              labelData={["Pending", "Accepted", "Declined"]}
            />
          </div>
          <StatsCards cards={statsCards} />

          {multiButtonSelect == "Pending" && (
            <WithDrawRequest
              endDate={endDateData}
              startDate={startDateData}
              multiButtonSelectNavigate={setMultiButtonSelect}
            />
          )}
          {multiButtonSelect == "Accepted" && (
            <AcceptedRequest endDate={endDateData} startDate={startDateData} />
          )}
          {multiButtonSelect == "Declined" && (
            <DeclinedRequest endDate={endDateData} startDate={startDateData} />
          )}
          {dialogueType === "pay" && <WithDrawDetails />}
          {dialogueType === "info" && <InfoDialog />}
          {dialogueType === "viewReason" && <ReasonViewDialog />}
        </div>
      </div>
    </>
  );
};

export default ManageWithDraw;
